<div class="separator-content">
  <div class="separator-label sp-mr-8 fs-12px" [attr.aria-label]="'hide_comments' | localize" (keydown.enter)="onHideComments()" (click)="onHideComments()" tabindex="0">
    {{ "hide_comments" | localize }}
  </div>
  <div class="separator-line sp-mt-2"></div>
</div>
